import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import menuIcon from "../../assets/icon-hamburger.svg";
const Header = (props) => {
  return (
    <header className="header">
      <div className="header-wrapper">
        <Link className="logo" to="/">
          THE PLANETS
        </Link>
        <img onClick={props.handler} className="menu-icon" src={menuIcon} />
        <ul>
          <li>
            <Link to="/mercury">Mercury</Link>
          </li>
          <li>
            <Link to="/venus">Venus</Link>
          </li>
          <li>
            <Link to="/earth">Earth</Link>
          </li>
          <li>
            <Link to="/mars">Mars</Link>
          </li>
          <li>
            <Link to="/jupiter">Jupiter</Link>
          </li>
          <li>
            <Link to="/saturn">Saturn</Link>
          </li>
          <li>
            <Link to="/uranus">Uranus</Link>
          </li>
          <li>
            <Link to="/neptune">Neptune</Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
